import styles from "../../../styles/shared/create-bot/CreateBotSettings.module.css";
import { FaBalanceScale, FaShieldAlt } from "react-icons/fa";
import { riskAppetiteColor, riskOptions } from "../../../utility/data";
import { BsExclamationTriangleFill } from "react-icons/bs";
import { HiRocketLaunch } from "react-icons/hi2";
import { AiTwotoneFire } from "react-icons/ai";
import { TbReportSearch } from "react-icons/tb";

function RiskPreferencesSettings({ changeConfig, selectedRisk }) {
  return (
    <>
      <div className={styles.stepTitle}>
        <h6>
          <TbReportSearch color="#0c4cfc" size={18} /> How would you rate your
          risk tolerance?
        </h6>
      </div>

      <ul className={`${styles.riskOptions}`}>
        {riskOptions.map((option, i) => (
          <li
            className={`${styles.riskItem} ${
              +selectedRisk === i + 1 ? styles.active : ""
            }`}
            key={option}
            data-color={riskAppetiteColor[i]}
            onClick={() => changeConfig("risk_tolerance", `${i + 1}`)}
            style={{ "--risk-color": riskAppetiteColor[i] }}
          >
            {i === 0 && <FaShieldAlt color="var(--risk-color)" />}
            {i === 1 && <BsExclamationTriangleFill color="var(--risk-color)" />}
            {i === 2 && <FaBalanceScale color="var(--risk-color)" />}
            {i === 3 && <HiRocketLaunch color="var(--risk-color)" />}
            {i === 4 && <AiTwotoneFire color="var(--risk-color)" />}
            {option}
          </li>
        ))}
      </ul>
    </>
  );
}

export default RiskPreferencesSettings;
